import './style.scss';

export const Maintenance = () => {
  return (
    <div className="maintenance_root">
      <p>
        ただいまメンテナンス中です。
        <br />
        ご迷惑をおかけし大変申し訳ございません。
        <br />
        メンテナンス終了までしばらくお待ちください。
      </p>
    </div>
  );
};
